import { useQuery } from '@tanstack/react-query';
import { PhotoCategoryApi } from 'api';

export function useGetPhotoCategories(vehicleId) {
  return useQuery({
    queryKey: ['photo-categories'],
    queryFn: () => PhotoCategoryApi.getAll(vehicleId),
  });
}
